<pane-back-button text="Close" class="p-3"></pane-back-button>
<div class="pane-content px-3">
    <div class="d-flex w-100 justify-content-start align-items-center">
        <div class="profile-image">
            <profile-image></profile-image>
        </div>
        <div class="d-flex flex-column placeholder-glow">
            <div class="profile-name" [class.placeholder]="!user">{{ user?.display_name ?? "Loading..." }}</div>
            <div class="profile-status" [class.placeholder]="!user">{{ user?.tag_line ?? "Loading... Loading..." }}</div>
        </div>
    </div>
    <hr>
    <div class="d-flex w-100 justify-content-center">
        <div class="btn-group" role="group" aria-label="Basic outlined example">
            <button type="button" class="btn btn-dark" (click)="editProfile()">Edit Profile</button>
            <button type="button" class="btn btn-dark">Share</button>
            <button type="button" class="btn btn-dark">Settings</button>
        </div>
    </div>
    <hr class="py-2">
    <div class="d-flex w-100 justify-content-center">
        <div class="btn-group" role="group" aria-label="Basic outlined example">
            <button type="button" class="btn btn-outline-danger" (click)="logout()">Sign out</button>
        </div>
    </div>
<!--    <div class="d-flex m-5 small">-->
<!--        Welcome. Binst is an amalgamation of nearly 10 years of my ideas.-->
<!--        My initial goal was to create something that does away with traditional-->
<!--        scroll interaction. In embarking on this journey I've often found myself-->
<!--        asking what do I want it to be? I'm all too surprised and bewildered-->
<!--        with the ideas that others see in what I'm building. So I think I'll-->
<!--        build something that let's others build the things that they see, and then I-->
<!--        can witness many great things.-->
<!--    </div>-->

    <div class="d-flex w-100 justify-content-center mt-5">
        <a class="mx-2" href="/terms-of-service">Terms of service</a>
        <a class="mx-2" href="/privacy">Privacy Policy</a>
    </div>
</div>